import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e380cca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Media Sosial")
  ])
], -1))
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center",
  role: "alert"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1))
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Berhasil!", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, "Berita berhasil ditambahkan", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-form-label required fw-bold fs-6" }, " Sumber Berita ", -1))
const _hoisted_12 = { class: "col-12 col-sm-10 fv-row" }
const _hoisted_13 = { class: "source-grid" }
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_16 = { class: "d-block fw-bold text-start" }
const _hoisted_17 = { class: "text-dark fw-bolder d-block fs-4 mb-2" }
const _hoisted_18 = { class: "text-gray-400 fw-bold fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_YoutubeFormInput = _resolveComponent("YoutubeFormInput")!
  const _component_InstagramFormInput = _resolveComponent("InstagramFormInput")!
  const _component_TwitterFormInput = _resolveComponent("TwitterFormInput")!
  const _component_FacebookFormInput = _resolveComponent("FacebookFormInput")!
  const _component_TiktokFormInput = _resolveComponent("TiktokFormInput")!
  const _component_LinkedInFormInput = _resolveComponent("LinkedInFormInput")!
  const _component_ReviewAppsFormInput = _resolveComponent("ReviewAppsFormInput")!
  const _component_ThreadsFormInput = _resolveComponent("ThreadsFormInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Form, {
      id: "kt_account_profile_details_form",
      class: "form",
      novalidate: "novalidate"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.is_show_alert)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inserted_id, (item, index) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: item,
                      class: "fw-bold ms-2",
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.showDetail(item))
                    }, [
                      _createElementVNode("u", null, "Lihat Berita " + _toDisplayString(index + 1), 1)
                    ], 8, _hoisted_9))
                  }), 128))
                ]),
                _createElementVNode("i", {
                  class: "bi bi-x ms-auto text-danger",
                  style: {"font-size":"20px","cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.is_show_alert = false))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.source, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.value
                  }, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.source,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.source) = $event)),
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: item.value,
                      id: item.value
                    }, null, 8, ["modelValue", "value", "id"]),
                    _createElementVNode("label", {
                      class: "source-card",
                      for: item.value
                    }, [
                      _createElementVNode("span", _hoisted_15, [
                        (item.value === 'youtube')
                          ? (_openBlock(), _createBlock(_component_inline_svg, {
                              key: 0,
                              src: "/media/icons/duotune/social/soc007.svg"
                            }))
                          : (item.value === 'instagram')
                            ? (_openBlock(), _createBlock(_component_inline_svg, {
                                key: 1,
                                src: "/media/icons/duotune/social/soc005.svg"
                              }))
                            : (item.value === 'twitter')
                              ? (_openBlock(), _createBlock(_component_inline_svg, {
                                  key: 2,
                                  src: "/media/icons/duotune/social/soc006.svg"
                                }))
                              : (item.value === 'facebook')
                                ? (_openBlock(), _createBlock(_component_inline_svg, {
                                    key: 3,
                                    src: "/media/icons/duotune/social/soc004.svg"
                                  }))
                                : (item.value === 'tiktok')
                                  ? (_openBlock(), _createBlock(_component_inline_svg, {
                                      key: 4,
                                      src: "/media/icons/duotune/social/soc008.svg"
                                    }))
                                  : (item.value === 'linkedin')
                                    ? (_openBlock(), _createBlock(_component_inline_svg, {
                                        key: 5,
                                        src: "/media/icons/duotune/social/linkedin.svg"
                                      }))
                                    : (item.value === 'review')
                                      ? (_openBlock(), _createBlock(_component_inline_svg, {
                                          key: 6,
                                          src: "/media/icons/duotune/social/soc002.svg"
                                        }))
                                      : (item.value === 'threads')
                                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                                            key: 7,
                                            src: "/media/icons/duotune/social/soc011.svg"
                                          }))
                                        : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(item.title), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getSubtitle(item.value)), 1)
                      ])
                    ], 8, _hoisted_14)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.source == 'youtube')
      ? (_openBlock(), _createBlock(_component_YoutubeFormInput, {
          key: 0,
          onSuccessInput: _ctx.getSuccessInputID
        }, null, 8, ["onSuccessInput"]))
      : (_ctx.source == 'instagram')
        ? (_openBlock(), _createBlock(_component_InstagramFormInput, {
            key: 1,
            onSuccessInput: _ctx.getSuccessInputID
          }, null, 8, ["onSuccessInput"]))
        : (_ctx.source == 'twitter')
          ? (_openBlock(), _createBlock(_component_TwitterFormInput, {
              key: 2,
              onSuccessInput: _ctx.getSuccessInputID
            }, null, 8, ["onSuccessInput"]))
          : (_ctx.source == 'facebook')
            ? (_openBlock(), _createBlock(_component_FacebookFormInput, {
                key: 3,
                onSuccessInput: _ctx.getSuccessInputID
              }, null, 8, ["onSuccessInput"]))
            : (_ctx.source == 'tiktok')
              ? (_openBlock(), _createBlock(_component_TiktokFormInput, {
                  key: 4,
                  onSuccessInput: _ctx.getSuccessInputID
                }, null, 8, ["onSuccessInput"]))
              : (_ctx.source == 'linkedin')
                ? (_openBlock(), _createBlock(_component_LinkedInFormInput, {
                    key: 5,
                    onSuccessInput: _ctx.getSuccessInputID
                  }, null, 8, ["onSuccessInput"]))
                : (_ctx.source == 'review')
                  ? (_openBlock(), _createBlock(_component_ReviewAppsFormInput, {
                      key: 6,
                      onSuccessInput: _ctx.getSuccessInputID
                    }, null, 8, ["onSuccessInput"]))
                  : (_ctx.source == 'threads')
                    ? (_openBlock(), _createBlock(_component_ThreadsFormInput, {
                        key: 7,
                        onSuccessInput: _ctx.getSuccessInputID
                      }, null, 8, ["onSuccessInput"]))
                    : _createCommentVNode("", true)
  ]))
}